module.exports = __webpack_public_path__ + "static/img/icon-news.e49326f8.svg";